export default __webpack_public_path__ + "static/media/cs-a009-4.168c3f8d.svg";